<template>
  <v-container
    fill-height
    fluid
  >
    <v-row
      justify="center"
    >
      <v-flex xs12 md6>
        <v-row justify="center">
          <material-card
            dark
            :title="$t('users.user_info')"
          >
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    v-if="form.cb_help_provider"
                    cols="12"
                  >
                    <v-text-field
                      readonly
                      v-model="form.cb_help_provider ? form.cb_help_provider.name : form.cb_help_provider"
                      :label="$t('users.helpProvider')"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      readonly
                      v-model="form.name"
                      :label="$t('users.name')"
                      class="purple-input"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      readonly
                      v-model="form.username"
                      class="purple-input"
                      :label="$t('users.username')"
                    />
                  </v-col>
                  <v-col
                    cols="3"
                    class="text-left"
                  >
                    Build 20220828
                  </v-col>
                  <v-col
                    cols="9"
                    class="text-right"
                  >
                    <v-btn
                      color="info"
                      @click="openEditUserDialog">
                      <v-icon class="pr-2">mdi-lock</v-icon>
                      {{ $t('users.change_password') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </material-card>
        </v-row>
      </v-flex>
    </v-row>
    <edit-user-details
      :dialog.sync="dialog"
      :dataForModal.sync="dataForModal"
      @closeEditUserDetailsDialog="dialog=false"
      @editedUser="editedUser"
    />
  </v-container>
</template>

<script>
  import axios from 'axios';
  import DialogEditUserDetails from "../components/user/DialogEditUserDetails";
  import MaterialCard from "../components/material/Card";

  export default {
    components: {
      MaterialCard,
      'edit-user-details': DialogEditUserDetails
    },
    data: function () {
      return {
        dataForModal: {},
        dialog: false,
        form: {
          name: '',
          username: '',
        }
      }
    },

    methods: {
      editedUser(data) {
        this.form.name = data.response.name
        this.form.username = data.response.username
      },
      openEditUserDialog() {
        this.dialog = true;
        this.dataForModal = {
          name: this.form.name,
          username: this.form.username,
          password: '',
          confirmPassword: '',
        }
      },
      retrieveCurrentUserData() {
        axios.post("api/users/retrieve_current_user_data")
          .then(response => {
          this.form = response.data;
        }).catch(error => {
          if (error.response.status === 401) {
            this.loading = false
            this.$swal.fire({
              type: 'info',
              title: "Info",
              text: this.$t('validation.session'),
            })
            this.$router.push('/login')
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: this.$t('validation.error'),
            })
          }
        });
      }
    },

    created() {
      this.retrieveCurrentUserData()
    }


  }
</script>
